import { Appointment, PartialService, Service } from '../types';

// One place for how prices read on screen. "Price varies" services are booked at
// $0 and priced by staff later, so they must never show as "$0" or "Free", and a
// booking that includes one never shows a dollar total.

export const PRICE_VARIES_LABEL = 'Price varies';
export const PRICE_AT_VISIT_LABEL = 'Price set at your visit';

export const formatMoney = (amount: number): string =>
  `$${(Math.round(amount * 100) / 100).toFixed(2).replace(/\.00$/, '')}`;

type PricedService = Pick<Service, 'price' | 'priceVaries'>;

export const formatServicePrice = (service: PricedService): string => {
  if (service.priceVaries) return PRICE_VARIES_LABEL;
  return service.price ? formatMoney(service.price) : 'Free';
};

// A line on a booking (servicesList item).
export const formatBookedServicePrice = (service: Pick<PartialService, 'serviceAmount' | 'priceVaries'>): string =>
  service.priceVaries ? PRICE_VARIES_LABEL : formatMoney(service.serviceAmount ?? 0);

export const servicesIncludeVariablePrice = (services: Array<{ priceVaries?: boolean }>): boolean =>
  services.some((service) => service.priceVaries === true);

// The total for a booking: a dollar amount only when every price is known.
export const formatBookingTotal = (
  appointment: Pick<Appointment, 'billingAmount' | 'priceToConfirm' | 'servicesList'>
): string => appointmentPriceIsPending(appointment) ? PRICE_AT_VISIT_LABEL : formatMoney(appointment.billingAmount ?? 0);

export const appointmentPriceIsPending = (
  appointment: Pick<Appointment, 'priceToConfirm' | 'servicesList'>
): boolean => appointment.priceToConfirm === true;
